import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
/**
 * Parse heatmap gradient.
 */
export function parseGradient(gradient) {
  if (typeof gradient === 'string') {
    return gradient.split(' ').map(function (stop) {
      var _stop$split = stop.split(':'),
        _stop$split2 = _slicedToArray(_stop$split, 2),
        r = _stop$split2[0],
        c = _stop$split2[1];
      return [+r, c];
    });
  }
  return gradient;
}